import React from "react";
import { BRAND } from "../data/site";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-black border-t border-white/10 py-16"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 font-display font-black uppercase text-2xl">
              <span className="inline-block w-2.5 h-2.5 bg-[#FF3B30]" />
              {BRAND.name}
            </div>
            <p className="mt-5 text-white/60 text-sm max-w-sm leading-relaxed">
              {BRAND.tagline} A fully‑remote creative shop serving ambitious
              Malaysian brands across Penang, KL and JB.
            </p>
            <a
              href={`mailto:${BRAND.email}`}
              data-testid="footer-email"
              className="mt-8 inline-flex items-center gap-2 font-display text-2xl md:text-3xl font-black uppercase hover:text-[#FF3B30] transition-colors"
            >
              {BRAND.email}
              <ArrowUpRight size={22} />
            </a>
          </div>

          <div className="md:col-span-2">
            <div className="text-[11px] uppercase tracking-[0.25em] text-white/40 mb-5">
              Navigate
            </div>
            <ul className="space-y-3 text-sm">
              {["services", "pricing", "locations", "book", "contact"].map((id) => (
                <li key={id}>
                  <button
                    data-testid={`footer-nav-${id}`}
                    onClick={() =>
                      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })
                    }
                    className="text-white/70 hover:text-[#FF3B30] uppercase tracking-[0.15em] text-xs"
                  >
                    {id}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-5">
            <div className="text-[11px] uppercase tracking-[0.25em] text-white/40 mb-5">
              Coverage
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-xs text-white/60">
              {BRAND.locations.map((l) => (
                <div key={l.city}>
                  <div className="text-white font-semibold mb-2 uppercase tracking-[0.15em]">
                    {l.city}
                  </div>
                  <div className="leading-relaxed">{l.coverage}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="hline my-12" />

        <div className="flex flex-col md:flex-row justify-between gap-4 text-[11px] uppercase tracking-[0.25em] text-white/40">
          <div>© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</div>
          <div>Made in Malaysia · Built to move brands.</div>
        </div>
      </div>
    </footer>
  );
}
